/**
 * "g" akorları (g d, g b, g l…) genel kısayol işleyicisinde yakalanır. Sayfa
 * işleyicileri pencereye daha önce bağlandığı için önce onlar çalışır; akor
 * sürerken tek harfli sayfa kısayollarını (l = dinle vb.) atlamaları gerekir.
 */
let gPendingAt = 0;

export function markChordStart() {
  gPendingAt = Date.now();
}

export function clearChord() {
  gPendingAt = 0;
}

export function chordActive(): boolean {
  return Date.now() - gPendingAt < 800;
}
